import initModals from './components/modal';
import initAppearAnim from "./utils/appear-anim";
import initDropdown from "./utils/dropdown";
import initTabs from './utils/tabs';
import initSimpleSwiper from './utils/simple-swiper';
import initReadMore from './utils/read-more';
import initFormFilters from "./components/form-filters";
import initAsideFilters from './components/aside-filters';
import initHeaderNavigation from './template-parts/header-navigation';
import initHeaderAccueil from "./blocks/header-accueil";
import initCarouselPosts from "./blocks/carousel-posts";
import initInteractiveMap from "./blocks/carte-interactive";
import initCustomNav from "./components/nav-custom";
import initSingleContentSlider from "./template-parts/single-content-slider";
import { initYoutubeIframe } from './components/youtube-iframe';
import initPasswordToggler from './components/password-toggler';
import initAgenda from './template-parts/agenda';
import initDropdownsBlock from './blocks/dropdowns';
import initPartnersSlider from './blocks/partners-slider';
import { initSearchAutocomplete, initSearchNbPerPageSelect } from './template-parts/search';
import initTeam from './blocks/team';
import initFederationFormationsSlider from './template-parts/federation-formations';
import initFederationMaillageActuEvent from './template-parts/federation-maillage-actu-event';
import initScrollProgressBar from './utils/reading-time';
import initAlert from './components/alert';
import initContactAssoSlider from './template-parts/association-header-slider';
import initUploadForm from './components/input-file';
import initDashboardToggleContent from './components/dashboard-toggle-content';
import initNotificationsDashboard from './template-parts/notifications';
import initTableauPrestation from './components/tableau-prestation';
import initEspaceExposant from './components/espace-exposant';
import initFavorites from './components/favorites';
import initNotificationsPreferences from './components/notifications-preferences';
import initLikes from './components/likes';
import initArchivePartenaires from './template-parts/archive-partenaires';
import initFormWithCart from './components/form-with-cart';
import initRetrievePassword from './template-parts/profile-password';
import initDownloadBlob from './components/download-blob';
import initbaseDocumentaireScroll from './template-parts/base-documentaire-scroll';
import { initAnnuaireSearchAutocomplete } from './template-parts/annuaire-search';
import { initBaseDocumentaireSearchAutocomplete } from './template-parts/base-documentaire-search';
import { initFormEventParticipant } from './template-parts/form-event-participant';
import initSubscribeForm from './components/subscribe-form';

// Fix de la valeur de "100vh" pour les appareils iOS + Fix de la valeur de "100vw"
function appHeight() {
    const vh = (window.innerHeight * 0.01) * 100;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    const vw = document.body.clientWidth;
    document.documentElement.style.setProperty('--vw', `${vw}px`);
}
window.addEventListener('load', appHeight);
window.addEventListener('resize', appHeight);

// Utils
initAppearAnim();
initDropdown();
initTabs();
initSimpleSwiper();
initScrollProgressBar();
initReadMore();
initUploadForm();
initDashboardToggleContent();

// Template parts
initHeaderNavigation();
initSingleContentSlider();
initAgenda();
initSearchNbPerPageSelect();
initFederationFormationsSlider();
initFederationMaillageActuEvent();
initSearchAutocomplete();
initContactAssoSlider();
initNotificationsDashboard();
initArchivePartenaires();
initDownloadBlob();
initbaseDocumentaireScroll();
initAnnuaireSearchAutocomplete();
initBaseDocumentaireSearchAutocomplete();
initFormEventParticipant();

// Blocks
initHeaderAccueil();
initCarouselPosts();
initInteractiveMap();
initDropdownsBlock();
initPartnersSlider();
initTeam();

// Components
initFormFilters();
initAsideFilters();
initModals();
initYoutubeIframe();
initPasswordToggler();
initCustomNav();
initAlert();
initEspaceExposant();
initTableauPrestation();
initFavorites();
initNotificationsPreferences();
initLikes();
initFormWithCart();
initRetrievePassword();
initSubscribeForm();
